import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import EntitiesIcon from '@material-ui/icons/Widgets';
import { selectEntity } from '../../actions';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5'
  }
})(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

export default function EntitySelector() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const entities = useSelector(state => state.entities.entities);
  const selected = useSelector(state => state.entities.selected);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = event => {
    setAnchorEl(null);
  };

  const handleMenuItemClose = entity => {
    setAnchorEl(null);
    dispatch(selectEntity(entity));
  };

  return (
    <div>
      <IconButton color="inherit" onClick={handleClick}>
        <EntitiesIcon />
      </IconButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {entities.map(entity => (
          <MenuItem
            key={entity.entityVersionId}
            onClick={() => handleMenuItemClose(entity)}
            selected={entity.entityVersionId === selected.entityVersionId}
          >
            {entity.displayName}
          </MenuItem>
        ))}
      </StyledMenu>
    </div>
  );
}
